<template>
  <div class="tabs-attachment tabs-common">
    <div class="d-flex align-items-center justify-content-between">
      <p class="common-title my-9">List of Items</p>
      <button class="btn btn-sm btn-success" v-if="!add_file" @click.prevent="addAttachment">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11H11V8C11 7.44772 11.4477 7 12 7Z" fill="white"/></svg>
      Add attachment</button>
    </div>
    <div class="table-wrap mb-2">
      <div class="table-head" v-if="tab_data.files && tab_data.files.length>0">
        <p style="flex: 1">#Item</p>
        <p>Type</p>
        <p>Reference Number</p>
        <p>Date</p>
        <p>File</p>
      </div>
      <div class="table-content">
        <div class="table-tr" v-for="(item,index) in tab_data.files" :key="index">
          <p style="flex: 1">{{ index + 1 }}</p>
          <p>{{ item.type }}</p>
          <p>{{ item.reference_number }}</p>
          <p>{{ item.date }}</p>
          <a style="color:#488E53;" :href="`/document/getfile/${item.id}`">Download</a>
          <button @click.prevent="removeFile(item, index)" class="btn btn-sm btn-link" style="color:#8e485a;"><i class="el-icon-delete"></i></button>
        </div>
      </div>
    </div>
    <!-- <div class="block_1 mb-4" v-if="add_file">
      
      <div class="d-flex" style="gap: 15px"><button class="btn btn-sm btn-outline-secondary" @click.prevent="add_file = false">Cancel</button><button class="btn btn-sm btn-success" @click.prevent="uploadFile">Add attachment</button></div>
    </div> -->
    <b-modal id="add-attachement" size="md" title="Add attachment" @ok="uploadFile()">
      <div class="mb-3 row">
        <div class="col-sm-12">
          <NewSelectWrapper type="attach_doc_types" v-model="new_file.type" placeholder="Attachment document Type"/>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-sm-12">
          <input type="text" class="form-control" v-model="new_file.reference_number" placeholder="Document reference number">
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-sm-12">
          <label for="new-attach-file" class="file-wrapper">
            <span>Choose file <span>{{ filename }}</span></span>
            <input type="file" id="new-attach-file" class="form-control" @change="handleFileSelect">
          </label>
        </div>
      </div>
      <template #modal-ok="{ hide }">
        Add
      </template>
    </b-modal>

    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'" @click="page_change('Goods',4)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('Endorsement',6)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import NewSelectWrapper from './../../fields/NewSelectWrapper.vue'

export default {
  name: 'tabs-attachment',
  components: {NewSelectWrapper},
  props: ['cur_tab_name', 'indata', 'document_id'],
  mixins: [common],
  methods: {
    /**
     * Removes file from the database (sending API request) and from the table on the page
     * @param {*} file 
     * @param {*} index 
     */
    removeFile(file, index){
      axios.get(`${window.base}/picture/DeleteFile/${file.id}`).then(()=>{
        this.tab_data.files.splice(index, 1)
      })
    },
    /**
     * Runs uploading of the file and adding it to database
     */
    uploadFile(){
      let form = new FormData;
      form.append('file', this.filehandler)
      form.append('type', this.new_file.type)
      form.append('reference_number', this.new_file.reference_number)
      form.append('doc_id', this.document_id)

      axios.post(`${window.base}/document/uploadDocument?docid=${this.document_id}`, form).then(response=>{
        if(this.tab_data.files)
          this.tab_data.files.push(response.data)
        else{
          this.tab_data.files = []
          this.tab_data.files.push(response.data)
        }
        this.add_file = false
        this.$bvModal.hide('add-attachement')
      })
    },
    /**
     * Display upload file form
     */
    addAttachment(){
      this.$bvModal.show('add-attachement')
      // this.add_file = true
    },
    /**
     * Handles file selected event
     * @param {*} event 
     */
    handleFileSelect(event){
      if(event.target.files){
        this.filehandler = event.target.files[0]
        this.filename = event.target.files[0].name
      }
    },
  },
  data() {
    return {
      add_file: false,
      new_file: {
        type: '',
        reference_number: '',
      },
      filehandler: null,
      filename: '',
      tab_data: {
        files: [],
      },
      list: [{
        type: 'Proforma Invoice',
        Number: '01',
        Date: '03/11/2022',
        File: 'Download',
      },{
        type: 'Certificate of insurance',
        Number: 'NGA-RCN23-021601-VO',
        Date: ' 29/06/2023 ',
        File: 'View Certificate',
      },{
        type: 'SON Product Certificate',
        Number: 'NGA-RCN23-021601-VO',
        Date: ' 29/06/2023 ',
        File: 'View SON Product Certificate',
      },{
        type: 'Certificate of insurance',
        Number: 'NGA-RCN23-021601-VO',
        Date: ' 29/06/2023 ',
        File: 'View Certificate',
      },]
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tabs-attachment {
  .table-wrap{
    .table-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 45px;
      line-height: 60px;
      background: #eee;
      font-size: 14px;
      font-weight: 600;
      P{
        flex: 3;
        margin: 0;
        padding: 0 15px;
        color: #000;
      }
    }
    .table-tr{
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      P{
        flex: 3;
        margin: 0;
        padding: 10px 15px;
        color: #333;
      }
    }
  }
}
</style>
<style>
  #add-attachement___BV_modal_content_ input.form-control,
  #add-attachement___BV_modal_content_ .el-select .el-input__inner, 
  #add-attachement___BV_modal_content_ .file-wrapper{
    border-radius: 8px !important;
    background: rgba(238, 238, 238, 0.93) !important;
    border: none !important;
    height: 56px !important;
    width: 100% !important;
  }
  #add-attachement___BV_modal_content_ .select-wrap,
  #add-attachement___BV_modal_content_ .select-wrap .el-select{
    display: block;
    width: 100%;
  }
  #add-attachement___BV_modal_content_ .file-wrapper{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    position: relative;
    font-size: 14px;
    color: #8D8D8DEE;
  }
  #add-attachement___BV_modal_content_ .file-wrapper span span{
    color: #333;
  }
  #add-attachement___BV_modal_content_ .file-wrapper input{
    width: 1px;
    overflow: hidden;
    opacity: 0;
    position: absolute;
  }
  #add-attachement___BV_modal_content_ .file-wrapper:after{
    content: "";
    background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.81125 2.33872C9.36521 2.11486 9.95849 2 10.557 2C11.1554 2 11.7487 2.11486 12.3027 2.33872C12.8567 2.56259 13.3614 2.89146 13.7867 3.30787C14.2121 3.72436 14.5496 4.22022 14.778 4.76761C15.0057 5.31315 15.1199 5.89802 15.1134 6.48823L15.1066 16.038L15.1065 16.0458C15.0933 16.8516 14.7529 17.6131 14.1701 18.168C13.5883 18.7219 12.8115 19.0269 12.0086 19.0269C11.2058 19.0269 10.429 18.7219 9.8472 18.168C9.26435 17.6131 8.92398 16.8516 8.91082 16.0458L8.91069 16.0376V8.74541C8.91069 8.19312 9.35841 7.74541 9.91069 7.74541C10.463 7.74541 10.9107 8.19312 10.9107 8.74541V16.0198C10.9167 16.2769 11.0259 16.5287 11.2263 16.7195C11.4295 16.913 11.71 17.0269 12.0086 17.0269C12.3073 17.0269 12.5878 16.913 12.791 16.7195C12.9915 16.5286 13.1007 16.2767 13.1066 16.0195L13.1134 6.46942C13.1174 6.15125 13.0562 5.83469 12.9323 5.53776C12.8084 5.24075 12.6238 4.96826 12.3875 4.73697C12.1512 4.50561 11.868 4.32018 11.5533 4.19304C11.2387 4.06588 10.8999 4 10.557 4C10.214 4 9.87525 4.06588 9.56057 4.19304C9.24593 4.32018 8.96268 4.50561 8.72637 4.73697C8.49013 4.96826 8.30556 5.24075 8.18163 5.53776C8.05774 5.83469 7.99645 6.15125 8.00044 6.46942L8.0006 6.48197L8.00052 16.1012L8.00041 16.1087C7.99288 16.6124 8.08887 17.1132 8.28368 17.5825C8.47853 18.0518 8.76882 18.4813 9.1394 18.8449C9.51005 19.2087 9.95358 19.4993 10.4451 19.6982C10.9366 19.8971 11.4653 20 12 20C12.5347 20 13.0634 19.8971 13.5549 19.6982C14.0464 19.4993 14.4899 19.2087 14.8606 18.8449C15.2312 18.4813 15.5215 18.0518 15.7163 17.5825C15.9111 17.1132 16.0071 16.6124 15.9996 16.1087L15.9995 16.1012V7.11188C15.9995 6.5596 16.4472 6.11188 16.9995 6.11188C17.5518 6.11188 17.9995 6.5596 17.9995 7.11188V16.0867C18.01 16.8622 17.8615 17.6313 17.5635 18.3493C17.2644 19.0696 16.8213 19.723 16.2614 20.2724C15.7017 20.8217 15.0365 21.2561 14.3053 21.5521C13.5742 21.848 12.7907 22 12 22C11.2093 22 10.4258 21.848 9.6947 21.5521C8.96352 21.2561 8.2983 20.8217 7.73856 20.2724C7.17874 19.723 6.73557 19.0696 6.43653 18.3493C6.13847 17.6313 5.98999 16.8622 6.00052 16.0866V6.48783C5.99403 5.89776 6.10829 5.31302 6.33587 4.76761C6.56427 4.22021 6.90181 3.72435 7.3272 3.30787C7.75251 2.89146 8.25724 2.56259 8.81125 2.33872Z" fill="%238D8D8D" fill-opacity="0.933333"/></svg>');
    width: 24px;
    height: 24px;
  }
  #add-attachement___BV_modal_content_ #add-attachement___BV_modal_title_{
    color: #488E53;
  }
  #add-attachement___BV_modal_content_ .btn.btn-primary,
  #add-attachement___BV_modal_content_ .btn.btn-primary:hover{
    background: #488E53 !important;
  }
  .btn.btn-success{
    background: #488E53 !important;
    border-color: #488E53 !important;
  }
</style>